import { Box, Text } from '@factorialco/deprecated-design-system'

const EmptyMessageContentPage = () => {
  return (
    <Box justifyContent="center" alignItems="center" height="full" padding="s64" gap="s24">
      <Text size="500">Welcome to your Mailbox!</Text>
      <Text size="300">
        Select an email from the list on the left to view its contents and details. Your messages
        will appear here once you choose one. Stay organized and connected with your emails.
      </Text>
    </Box>
  )
}

export default EmptyMessageContentPage
